export const incrementProfileTrigger = () => {
  return {
    type: "INCREMENT_PROFILE_TRIGGER",
  };
};
